import * as Yup from 'yup'

const studentSchema = Yup.object({
  nome: Yup.string().required('O nome é obrigatório'),
  ra: Yup.string().required('O RA é obrigatório')
})

export default studentSchema
